module.exports = __webpack_public_path__ + "static/media/banner-frames.5b63ee24.png";